module.exports = __webpack_public_path__ + "img/tf.4ab43cc.svg";